import React, { FC } from 'react';
import { IconDownloadFill } from '@saucelabs/ds-icons';
import { IconButton } from '@saucelabs/ds-button';
import { Tooltip } from '@saucelabs/ds-tooltip';
import { saveAs } from 'file-saver';

import { track } from '../../global/tracking';
import { ImageType } from '../../global/constants';

type Props = {
  url: string;
  title: string;
  id: string;
  type: ImageType;
  className?: string;
} & React.HTMLAttributes<HTMLButtonElement>

const DownloadImage: FC<Props> = ({ url, id, type, className, title, ...other }) => {
  const onClick = () => {
    track.downloadClicked({
      resource_type: type,
      resource_id: id,
    });
    // image filename can be changed only on the backend
    saveAs(url);
  };

  return (
    <Tooltip
      placement="top"
      title={title}
    >
      <IconButton
        {...other}
        className={className}
        color="primary"
        icon={<IconDownloadFill />}
        onPress={onClick}
        size="md"
        variant="text"
      />
    </Tooltip>
  );
};

export default DownloadImage;
